import React from "react";
import { LinearProgress } from "@mui/material";

const MissingProgressBar = ({ value = 0 }) => (
  <LinearProgress
    variant="determinate"
    value={value}
    sx={{
      height: 8,
      borderRadius: "999px",
      backgroundColor: "#d8d8d8",
    }}
  />
);

export default MissingProgressBar;
